import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout-Route fuer /vertraege. Reine Wrapper-Komponente — Inhalt liegt in
 * vertraege.index.tsx etc. (L-13: Parent muss <Outlet /> rendern, nicht den
 * Inhalt selbst, sonst overshadowed das Parent die Children).
 */
export const Route = createFileRoute('/vertraege')({
  component: VertraegeLayout,
});

function VertraegeLayout() {
  return <Outlet />;
}
